/* eslint-disable no-param-reassign */
/* eslint-disable max-len */

import { actionStruct } from '../utils';

const Types = {
  ADD: 'cart/add',
  REMOVE: 'cart/remove',
  UPDATE_QTY: 'cart/update-qty'
};

const INITIAL_VALUE = [];

export const addProductFromCart = (product, qty = 1) => actionStruct(Types.ADD, { product, qty });
export const removeProductFromCart = (productIndex) => actionStruct(Types.REMOVE, { productIndex });
export const updateQtyFromCart = (productIndex, qty) =>
  actionStruct(Types.UPDATE_QTY, { productIndex, qty });

export const reducer = (state = INITIAL_VALUE, action) => {
  const { type, payload } = action;
  const removeCallback = (_product, i) => i !== payload.productIndex;
  const cleanState = state.filter((cart) => cart && !Array.isArray(cart));
  const parseQty = (qty) => (qty < 1 ? 1 : qty);
  const parseCart = ({ product, qty }) => ({ product, qty: parseQty(qty) });

  switch (type) {
    case Types.ADD:
      return cleanState.concat(parseCart(action.payload));

    case Types.REMOVE:
      return cleanState.filter(removeCallback);

    case Types.UPDATE_QTY: {
      const { productIndex, qty } = payload;

      if (!state[productIndex]) {
        return cleanState;
      }

      const cart = cleanState;
      cart[productIndex].qty = parseQty(qty);
      return cart;
    }

    default:
      return cleanState;
  }
};
